module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    ref: "menu",
    staticClass: "menu-wrap"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.goods), function(menu, index) {
    return _c('li', {
      staticClass: "menu-item border-1px",
      class: {
        current: index === _vm.currentIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectMenu(index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.type > -1),
        expression: "menu.type > -1"
      }],
      staticClass: "icon",
      class: _vm.classMap[menu.type]
    }), _c('span', [_vm._v(_vm._s(menu.name))])])])
  }))]), _vm._v(" "), _c('div', {
    ref: "foods",
    staticClass: "foods-wrap"
  }, [_c('ul', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goods), function(good) {
    return _c('li', {
      staticClass: "goods-item goods-item-hook"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(good.name))]), _vm._v(" "), _c('ul', {
      staticClass: "foods-list"
    }, _vm._l((good.foods), function(food) {
      return _c('li', {
        staticClass: "food border-1px",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.selectFoodData(food, $event)
          }
        }
      }, [_c('img', {
        staticClass: "food-image",
        attrs: {
          "src": food.icon,
          "alt": "图片"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "food-content"
      }, [_c('h4', {
        staticClass: "food-name"
      }, [_vm._v(_vm._s(food.name))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.description),
          expression: "food.description"
        }],
        staticClass: "desc"
      }, [_vm._v(_vm._s(food.description))]), _vm._v(" "), _c('div', {
        staticClass: "count-rating"
      }, [_c('span', {
        staticClass: "count"
      }, [_vm._v("月售" + _vm._s(food.sellCount))]), _vm._v(" "), _c('span', {
        staticClass: "rating"
      }, [_vm._v("好评率" + _vm._s(food.rating) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "price-wrap"
      }, [_c('span', {
        staticClass: "price"
      }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(food.price))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "old-price"
      }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(food.oldPrice))])])]), _vm._v(" "), _c('div', {
        staticClass: "control-wrap"
      }, [_c('control', {
        attrs: {
          "food": food
        }
      })], 1)])
    }))])
  }))]), _vm._v(" "), _c('shopcart', {
    attrs: {
      "selectFoods": _vm.selectFoods
    }
  }), _vm._v(" "), _c('food', {
    ref: "food",
    attrs: {
      "food": _vm.selectFood
    },
    on: {
      "hide": _vm.hideFood
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32447d73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goods/goods.vue
// module id = 72
// module chunks = 0